import React from 'react';
import getConfig from 'next/config';

import Container from 'components/Container';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { basePath }
} = getConfig();

const PromoSection = () => {
	const currentYear = new Date().getFullYear();

	return (
		<div className={styles.PromoSection}>
			<div
				className={styles.PromoSection__Cover}
				style={{ backgroundImage: `url(${basePath}/images/main_poster.jpeg)` }}
			>
				<Container className={styles.PromoSection__ContainerCover}>
					<h1 className={styles.PromoSection__Title}>
						Выставки музеев—{currentYear}
						<br />
						Планируем культурные выходные
						<br />
						на&nbsp;весь&nbsp;год
					</h1>
				</Container>
			</div>
			<Container>
				<div className={styles.PromoSection__Description}>
					<div>
						В {currentYear} году федеральные музеи представят более 2,5 тысяч
						новых проектов. По всей стране уже проходят специальные программы,
						необычные экспозиции, межмузейные проекты и многие другие события.
					</div>
					<div>
						Узнать, что готовят музеи в разных городах России, и запланировать
						культурные выходные на весь год можно уже сейчас благодаря афише
						портала{' '}
						<a href="https://www.culture.ru" target="_blank">
							«Культура.РФ»
						</a>
						. Ищите актуальные выставки по тегу{' '}
						<a
							href={`https://www.culture.ru/afisha/russia/tags-vystavkimuzeev${currentYear}`}
							target="_blank"
						>
							«ВыставкиМузеев{currentYear}»
						</a>
						.
					</div>
					<div>
						А на этой странице мы собрали яркие и масштабные проекты, на которые
						в этом году точно стоит обратить внимание ценителям искусства. Не
						пропустите интересные события в музеях вашего города!
					</div>
				</div>
			</Container>
		</div>
	);
};

export default PromoSection;
